// extracted by mini-css-extract-plugin
export default {"container":"styles_container__wLyCz","itemList":"styles_itemList__++IZr","itemListReversed":"styles_itemListReversed__navj7"};